import * as adminI18nSettings from '@innovyze/app_admin/Translations';
import * as amAssetUploadI18nSettings from 'fed_app_am_data_management/Translations';
import * as amCommonI18nSettings from '@innovyze/lib-am-common/Translations';
import * as assetsI18nSettings from '@innovyze/app-am-network/Translations';
import * as innoMapI18nSettings from '@innovyze/inno-map/Translations';
import * as inspectionsI18nSettings from '@innovyze/app-am-activities/Translations';
import * as libMapsI18nSettings from '@innovyze/map-components/Translations';
import * as rehabI18nSettings from '@innovyze/app-am-rehab/Translations';
import * as riskI18nSettings from '@innovyze/app-am-risk/Translations';
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import * as stylovyzeI18nSettings from '@innovyze/stylovyze/translations/Translations.json';

import assetI18nSettings from './settings.json';
import { getTranslationFile } from '@innovyze/lib_asset_schema';
import { locales } from '@innovyze/stylovyze';

export const globalization = {
	bundles: [
		...locales.map(locale => ({
			language: locale,
			namespace: assetI18nSettings.ns,
			file: import(`../../data/translations/${locale}.json`),
		})),
		...locales.map(locale => ({
			language: locale,
			namespace: stylovyzeI18nSettings.ns,
			file: import(`@innovyze/stylovyze/translations/${locale}.json`),
		})),
		...locales.map(locale => ({
			language: locale,
			namespace: adminI18nSettings.ns,
			file: import(`@innovyze/app_admin/translations/${locale}.json`),
		})),
		...locales.map(locale => ({
			language: locale,
			namespace: assetsI18nSettings.ns,
			file: import(
				`@innovyze/app-am-network/translations/${locale}.json`
			),
		})),
		...locales.map(locale => ({
			language: locale,
			namespace: riskI18nSettings.ns,
			file: import(`@innovyze/app-am-risk/translations/${locale}.json`),
		})),
		...locales.map(locale => ({
			language: locale,
			namespace: inspectionsI18nSettings.ns,
			file: import(
				`@innovyze/app-am-activities/translations/${locale}.json`
			),
		})),
		...locales.map(locale => ({
			language: locale,
			namespace: rehabI18nSettings.ns,
			file: import(`@innovyze/app-am-rehab/translations/${locale}.json`),
		})),
		...locales.map(locale => ({
			language: locale,
			namespace: amAssetUploadI18nSettings.ns,
			// TODO: apparently this repo app-am-data-management was not fully federated, since the npm package is still utilized here
			// At the same time, we don't really have translations in place for this app.
			// As such, until we have translations, app_am_main can still pull this package.
			// But once we will actually need translations in place, we will need to fully federate this.
			file: import(
				`@innovyze/app-am-data-management/translations/${locale}.json`
			),
		})),
		...locales.map(locale => ({
			language: locale,
			namespace: amCommonI18nSettings.ns,
			file: import(`@innovyze/lib-am-common/translations/${locale}.json`),
		})),
		...locales.map(locale => ({
			language: locale,
			namespace: innoMapI18nSettings.ns,
			file: import(`@innovyze/inno-map/translations/${locale}.json`),
		})),
		...locales.map(locale => ({
			language: locale,
			namespace: libMapsI18nSettings.ns,
			file: import(
				`@innovyze/map-components/translations/${locale}.json`
			),
		})),
		...locales.map(locale => ({
			language: locale,
			namespace: 'asset-main',
			file: import(`../../data/translations/${locale}.json`),
		})),
		...locales.map(locale => ({
			language: locale,
			namespace: 'lib-asset-schema',
			file: getTranslationFile(locale),
		})),
	],
};
